<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-copyright element-without-heading full-character-formatting" id="copyright">
<div class="text" id="copyright-text">
<p class="first first-in-chapter first-full-width copyright-content">Disclaimer . . .</p>
<p class="subsq copyright-content">This book is a work of nonfiction. The accounts are from the authors’ perspective and from memories, and as such, are represented as accurately and faithfully as possible as submitted. This book is not written on behalf of, nor endorsed by, the social media app currently known as Clubhouse. This book is merely to describe experiences of the contributors of what they have encountered with its use and application.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content"><i>Powerhouse Voices: Amazing Experiences of Clubhouse Volume 2</i></p>
<p class="subsq copyright-content">Copyright © 2022 by Naleighna Kai for Macro Publishing Group and The Macro Group LLC</p>
<p class="subsq copyright-content">All rights reserved.</p>
<p class="subsq copyright-content">Without limiting the rights under copyright reserved above, no part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted, in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the express written permission of both the copyright owner and the publisher of this book, except in the case of brief quotations embodied in critical articles and reviews. For permission, contact <a class="content-external-link text-is-url" href="mailto:naleighnakai@gmail.com">naleighnakai@gmail.com</a></p>
<p class="subsq copyright-content">.</p>
<p class="subsq copyright-content">The scanning, uploading, and distribution of this book via the Internet or via any other means without the permission of the owner is illegal and punishable by law. Please purchase only authorized electronic editions and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the authors’ rights is appreciated.</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">Ebook ISBN: 9781952871405</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">Macro Publishing Group</p>
<p class="subsq copyright-content">1507 E. 53rd Street, #858</p>
<p class="subsq copyright-content">Chicago, IL 60615</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width copyright-content">Cover Designed by: J.L Woodson: <a class="content-external-link" href="http://www.woodsoncreativestudio.com/" target="_blank">www.woodsoncreativestudio.com</a> / jlwoodson@woodsonstudio.com</p>
<p class="subsq copyright-content">Interior Designed by: Lissa Woodson: <a class="content-external-link" href="http://www.naleighnakai.com/" target="_blank">www.naleighnakai.com</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?55e10d73